import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import { useNavigate } from 'react-router-dom'
import OrganizationsFilters from './componenets/OrganizationsFilters'
import OrganiaztionsTable from './componenets/OrganizationsTable'

const OrganizationsPage = () => {
  const navigate = useNavigate()

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Организации</h2>
          </div>
          <div className='inline-flex-gap'>
            <Button theme='primary' onClick={() => navigate('/admin/organizations/create')}>
              <span className='inline-flex-gap' style={{ gap: '0.5em' }}>
                <span>+</span>
                <span>Создать</span>
              </span>
            </Button>
          </div>
        </div>
        <OrganizationsFilters />
        <OrganiaztionsTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default OrganizationsPage
